var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1276",
    "data-name": "Group 1276",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.305,
    height: 16.305,
    viewBox: "0 0 16.305 16.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M332.407,260.989a8.153,8.153,0,1,1-8.153-8.153,8.153,8.153,0,0,1,8.153,8.153",
    transform: "translate(-316.102 -252.836)",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.507,327.5h-2.663v-3a.646.646,0,1,0-1.286,0v3h-2.663a.71.71,0,0,0,0,1.413h2.663v2.859a.646.646,0,1,0,1.286,0v-2.859h2.663a.71.71,0,0,0,0-1.413",
    transform: "translate(-386.812 -319.991)",
    fill: "#06399DE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.85f91339beaaf3e77ab4e0d71c9d8e11.svg";
export { ForwardRef as ReactComponent };